import {
  defaultRuleProcessorJsonLogic,
  formatQuery as rqbFormatQuery,
} from 'react-querybuilder/formatQuery';

import {
  type JsonLogic,
  type QueryBuilderRuleGroupType,
  ruleProcessorJsonLogicExtended,
} from '@dotfile/shared/domain';

/**
 * Format a ReactQueryBuilder rule group to a JsonLogic object
 *
 * @param query - The ReactQueryBuilder rule group to format
 * @returns A JsonLogic object that represents the ReactQueryBuilder rule group
 * @see https://react-querybuilder.js.org/docs/utils/export#jsonlogic
 * @see https://jsonlogic.com/
 */
export const formatJsonLogic = (query: QueryBuilderRuleGroupType): JsonLogic =>
  rqbFormatQuery(query, {
    format: 'jsonlogic',
    // When adding new option, keep in sync with the tests in
    // libs/shared/domain/src/lib/modules/client-portal/client-portal-logic/get-logic-builder-operators.spec.ts
    ruleProcessor: (rule, options) => {
      const extendedRule = ruleProcessorJsonLogicExtended(rule);
      if (extendedRule) return extendedRule;
      return defaultRuleProcessorJsonLogic(rule, options);
    },
  });
